import React, { FC } from "react";
import type { AutomationPrecisionKytProps } from "@/types";
import { Cta } from "../cta";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const AutomationPrecisionKyt: FC<AutomationPrecisionKytProps> = ({
  content,
  cta,
  cover,
}) => {
  return (
    <section className="automationPrecisionKyt">
      <div className="automationPrecisionKyt--inner">
        <div className="wrapper">
          <TextCols content={content} maxTitleWidth={871} />
        </div>
        <div className="wrapper wrapper_lg">
          {/* TODO: Temporary hidden */}
          {/* <Cta
            cta={cta}
            theme="light"
            className="automationPrecisionKyt--cta"
          /> */}
          {cover?.file?.url && (
            <Image
              className="automationPrecisionKyt--cover"
              src={cover as any}
              alt={cover.title}
            />
          )}
        </div>
      </div>
    </section>
  );
};
